












import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Flickity from 'vue-flickity'
import imagesLoaded from 'vue-images-loaded'

@Component({
  components: { Flickity },
  directives: { imagesLoaded }
})
export default class ModuleGallery extends Vue {
  ready = false
  index = null
  show = false
  $refs: {
    flickity: any
  }

  flickityOptions = {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    cellAlign: 'left'
  }

  @Prop() images
  @Prop({ type: Boolean, default: false}) background
  @Prop({ type: Boolean }) current: boolean

  @Watch('current', { immediate: true})
  setCurrent(current) {
    this.show = current
  }

  updateIndex(index) {
    this.index = ++index
  }

  initFlickity() {
    this.ready = true
    this.index = this.$refs.flickity.selectedIndex() + 1
    this.$refs.flickity.on('change', this.updateIndex)
  }

  imgsLoaded() {
    // console.log('image loaded', this.images)
    this.$refs.flickity.reloadCells()
    // this.$refs.flickity.flickity('resize')
  }

}
